var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"background"}},[_c('div',{attrs:{"id":"background-image"}}),_c('form-cad-cliente')],1)}
var staticRenderFns = []

export { render, staticRenderFns }